//
//
//
//
//
//
//

export default {
  name: 'SubscribeForm2026PlanHeader',
  props: {
    title: {
      type: String,
      default: undefined,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    displayTitle() {
      return this.title || this.$t('subscribe.form_2026_plan_title');
    },
    displaySubtitle() {
      return this.subtitle || this.$t('subscribe.form_2026_plan_subtitle');
    },
  },
};
